// deps
import React, { memo } from "react";

// widgets
import Tooltip from "@cart-ui/widgets/Tooltip";

interface DeliverySpeedPointTooltipProps {
    children: JSX.Element | JSX.Element[];
    triggerRef: React.RefObject<HTMLDivElement>;
    position: { x: number; y: number };
    widgetSize: string;
    onHide: VoidFunction;
}

function DeliverySpeedPointTooltip(props: DeliverySpeedPointTooltipProps) {
    const { triggerRef, position, widgetSize, children, onHide } = props;

    const handleClick = (e: React.MouseEvent) => e.stopPropagation();

    return (
        <div onClick={handleClick}>
            <Tooltip triggerRef={triggerRef} position={position} widgetSize={widgetSize} hide={onHide}>
                {children}
            </Tooltip>
        </div>
    );
}

export default memo(DeliverySpeedPointTooltip);
